export default __webpack_public_path__ + "static/building_blocks-07083fd7c2a7d7f9df18b1bef3928fa8.svg";